import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "@babel/runtime/helpers/esm/get";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/esm/applyDecoratedDescriptor";
var _dec, _class;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
import Immutable, { Map, List } from 'immutable';
import { interactionPoints } from '@instructure/quiz-interactions';
import { toErrors } from '../../common/util/instUIMessages';
import ReduxRecord from './reduxRecord';
import _Item from './Item';
import _Bank from './Bank';
import _Stimulus from './Stimulus';
import _BankEntry from './BankEntry';
import { TEMPORARY_ITEM_ID, TEMPORARY_STIMULUS_ID, TEMPORARY_QUIZ_ENTRY_ID, REMOVE, MOVE, EDIT, COPY } from '@instructure/quiz-common';
import { mergeDeepOnlyMaps } from '../util/immutableHelpers';
import withStateCache from '../util/withStateCache';
import t from '@instructure/quiz-i18n/es/format-message';
var acceptedVerbs = [REMOVE, MOVE, EDIT, COPY];
export var QuizEntry = (_dec = withStateCache(function () {
  return [['quizEntries'], ['modifications', 'quizEntries']];
}), _class = /*#__PURE__*/function (_ReduxRecord) {
  function QuizEntry() {
    var _this;
    _classCallCheck(this, QuizEntry);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, QuizEntry, [].concat(args));
    _defineProperty(_this, "__getStimulusEntries", function () {
      var childEntries = _this.getState().get('quizEntries', Map()).filter(function (entry) {
        return entry.get('stimulusQuizEntryId') === _this.id;
      });
      var temporaryItem = _this.getState().getIn(['modifications', 'quizEntries', TEMPORARY_QUIZ_ENTRY_ID]);
      if (temporaryItem && temporaryItem.get('stimulusQuizEntryId') === _this.id) {
        childEntries = childEntries.set(temporaryItem.id, QuizEntry.create(temporaryItem));
      }
      var quizEntries = childEntries.map(function (entry) {
        return QuizEntry.create(entry);
      }).sortBy(function (qe) {
        return qe.position;
      }).toList();
      return quizEntries || List();
    });
    _defineProperty(_this, "__getBankEntryEntries", function () {
      if (_this.hasStimulus) {
        return _this.__getStimulusEntries();
      } else {
        return List([_this]);
      }
    });
    return _this;
  }
  _inherits(QuizEntry, _ReduxRecord);
  return _createClass(QuizEntry, [{
    key: "getErrors",
    value: function getErrors() {
      return _superPropGet(QuizEntry, "getErrors", this, 3)([this]).merge({
        sampleNum: this.sampleNumErrors(),
        deletedBank: this.deletedBankErrors(),
        pointsPossible: this.pointsPossibleErrors()
      });
    }
  }, {
    key: "isNumber",
    value: function isNumber(numString) {
      return Number(numString).toString() === numString;
    }
  }, {
    key: "sampleNumErrors",
    value: function sampleNumErrors() {
      var errors = [];
      var selection = this.selection;
      if (!this.isBank || selection === 'all' || this.isArchivedBank) {
        return toErrors(errors);
      }
      var sample = this.properties.get('sampleNum', '');
      var parsedNumber = parseInt(sample, 10);
      if (parsedNumber < 1) {
        errors.push(t('Must be at least 1'));
      }
      if (parsedNumber > this.getEntry().itemEntryCount) {
        errors.push(t("{ number, plural,\n          one {Max number exceeded (this bank contains 1 question)}\n          other {Max number exceeded (this bank contains # questions)}\n        }", {
          number: this.getEntry().itemEntryCount
        }));
      }
      if (!Number.isInteger(Number(sample)) || isNaN(parsedNumber) || !this.isNumber(sample)) {
        errors.push(t('Must be a whole number'));
      }
      return toErrors(errors);
    }
  }, {
    key: "deletedBankErrors",
    value: function deletedBankErrors() {
      var errors = [];
      if (this.isArchivedBank) {
        errors.push(t('This item bank no longer exists. Please select a valid bank.'));
      }
      return toErrors(errors);
    }
  }, {
    key: "pointsPossibleErrors",
    value: function pointsPossibleErrors() {
      var errors = [];
      var possible = this.pointsPossible;
      if (!this.isNumber(possible.toString())) {
        errors.push(t('Must be a number'));
      }
      if (Number(possible) < 0) {
        errors.push(t('Must be greater than or equal to 0'));
      }
      return toErrors(errors);
    }
  }, {
    key: "getEntry",
    value: function getEntry() {
      var _this2 = this;
      var entry;
      if (this.entry === TEMPORARY_ITEM_ID) {
        entry = _Item.create(this.getState().getIn(['modifications', 'items', TEMPORARY_ITEM_ID]));
      } else if (this.entry === TEMPORARY_STIMULUS_ID) {
        entry = _Stimulus.create(this.getState().getIn(['modifications', 'stimuli', TEMPORARY_STIMULUS_ID]));
      }
      if (entry === void 0) {
        var entryId = this.entryId || this.entry.get('id');
        var entryCreator = {
          Bank: function Bank() {
            return _Bank.create(_this2.getState().getIn(['banks', entryId]));
          },
          BankEntry: function BankEntry() {
            return _BankEntry.create(_this2.getState().getIn(['bankEntries', entryId]));
          },
          Item: function Item() {
            return _Item.create(_this2.getState().getIn(['items', entryId]));
          },
          Stimulus: function Stimulus() {
            return _Stimulus.create(_this2.getState().getIn(['stimuli', entryId]));
          }
        };
        if (!entryCreator[this.entryType]) return;
        entry = entryCreator[this.entryType]();
      }
      entry.quizEntry = this;
      return entry;
    }
  }, {
    key: "getItem",
    value: function getItem() {
      var entry = this.getEntry();
      var itemCreator = {
        BankEntry: function BankEntry() {
          return entry.getEntry();
        },
        Item: function Item() {
          return entry;
        }
      }[this.entryType];
      if (!itemCreator) return;

      // Assume we want working item if accessed on working quiz entry.
      var item = itemCreator();
      if (!item) return;
      var currentItem = this.isWorkingInstance ? item.getWorkingInstance() : item;
      var overrides = this.getWorkingInstance().properties.get('itemOverrides');
      return currentItem.mergeWith(mergeDeepOnlyMaps, overrides);
    }
  }, {
    key: "getNestedEntries",
    value:
    // This will currently trigger rerendering of all stimuli if any QuizEntry changes.
    // Possibly the `withStateCache` decorator could be made more sophisticated to deal
    // with this flaw.
    function getNestedEntries() {
      var _this3 = this;
      var getNestedEntriesFunction = {
        Bank: function Bank() {
          return List([_this3]);
        },
        BankEntry: this.__getBankEntryEntries,
        Item: function Item() {
          return List([_this3]);
        },
        Stimulus: this.__getStimulusEntries
      }[this.entryType];
      return getNestedEntriesFunction ? getNestedEntriesFunction() : List();
    }
  }, {
    key: "getProperties",
    value: function getProperties() {
      return {
        points_possible: this.pointsPossible && parseFloat(this.pointsPossible),
        position: this.position && Math.ceil(this.position),
        stimulus_quiz_entry_id: this.stimulusQuizEntryId
      };
    }
  }, {
    key: "regradeAdjustedScoringData",
    value: function regradeAdjustedScoringData(itemId) {
      if (this.quizEntryRegrades.isEmpty()) {
        return this.get('regradeAdjustedScoringData');
      }
      var qerForItem = this.quizEntryRegrades.find(function (qer) {
        return qer.get('itemId') == itemId;
      });
      return qerForItem && qerForItem.get('scoringData');
    }
  }, {
    key: "regradeAdjustedPointsPossible",
    value: function regradeAdjustedPointsPossible(itemId) {
      if (this.quizEntryRegrades.isEmpty()) {
        return this.get('regradeAdjustedPointsPossible');
      }
      var qerForItem = this.quizEntryRegrades.find(function (qer) {
        return qer.get('itemId') == itemId;
      });
      return qerForItem && qerForItem.get('pointsPossible');
    }
  }, {
    key: "regradeScoringAlgorithm",
    value: function regradeScoringAlgorithm(itemId) {
      var qerForItem = this.quizEntryRegrades.find(function (qer) {
        return qer.get('itemId') == itemId;
      });
      return qerForItem && qerForItem.get('scoringAlgorithm');
    }
  }, {
    key: "isImmutable",
    value: function isImmutable() {
      return this.status === 'immutable';
    }
  }, {
    key: "hasModifications",
    value: function hasModifications() {
      return !Immutable.is(this.getWorkingInstance()["delete"]('isWorkingInstance'), this["delete"]('isWorkingInstance'));
    }
  }, {
    key: "getWorkingInstance",
    value: function getWorkingInstance() {
      var data = this.mergeWith(mergeDeepOnlyMaps, this.getState().getIn(['modifications', 'quizEntries', this.id])).set('isWorkingInstance', true);
      return QuizEntry.create(data);
    }
  }, {
    key: "isArchivedBankEntry",
    get: function get() {
      return this.isBankEntry && this.getEntry().archived;
    }
  }, {
    key: "isArchivedBank",
    get: function get() {
      return this.isBank && this.getEntry().archived;
    }
  }, {
    key: "hasStimulus",
    get: function get() {
      var hasStim = Boolean(this.isBankEntry && this.getEntry() && this.getEntry().getEntry() && this.getEntry().getEntry().isStimulus);
      return this.isStimulus || hasStim;
    }
  }, {
    key: "hasNestedRecords",
    get: function get() {
      return this.hasStimulus;
    }
  }, {
    key: "isBank",
    get: function get() {
      return this.entryType === 'Bank';
    }
  }, {
    key: "isBankEntry",
    get: function get() {
      return this.entryType === 'BankEntry';
    }
  }, {
    key: "isStimulus",
    get: function get() {
      return this.entryType === 'Stimulus';
    }
  }, {
    key: "isPassage",
    get: function get() {
      return Boolean(this.isStimulus && this.getEntry() && this.getEntry().passage);
    }
  }, {
    key: "isItem",
    get: function get() {
      return this.entryType === 'Item';
    }
  }, {
    key: "isInStimulus",
    get: function get() {
      return !isNaN(parseInt(this.stimulusQuizEntryId, 10));
    }
  }, {
    key: "isTemporary",
    get: function get() {
      return this.id === TEMPORARY_QUIZ_ENTRY_ID;
    }
  }, {
    key: "type",
    get: function get() {
      return this.entryType;
    }
  }, {
    key: "pointsPossible",
    get: function get() {
      if (this.hasStimulus) {
        return 0;
      }
      var item = this.getItem();
      var itemPoints = item && interactionPoints(item.toJS());
      return itemPoints === void 0 ? this.get('pointsPossible') : itemPoints;
    }
  }, {
    key: "bankPointsPossible",
    get: function get() {
      if (!this.isBank) {
        return this.pointsPossible;
      }
      return this.sizeOfBank * this.get('pointsPossible');
    }
  }, {
    key: "sampleNum",
    get: function get() {
      return parseInt(this.properties.get('sampleNum'), 10);
    }
  }, {
    key: "selection",
    get: function get() {
      return this.properties.get('selection') || (this.sampleNum > 0 ? 'rand' : 'all');
    }
  }, {
    key: "numItems",
    get: function get() {
      if (this.isBank && this.sizeOfBank === 0) {
        return 0;
      }
      return this.displayPositionSlots > this.sizeOfBank ? this.displayPositionSlots : this.sizeOfBank;
    }
  }, {
    key: "generateScreenReaderText",
    value: function generateScreenReaderText() {
      var displayPosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var verb = arguments.length > 1 ? arguments[1] : undefined;
      if (!acceptedVerbs.includes(verb)) {
        console.error("".concat(verb, " not an accepted verb. Must be one of ").concat(acceptedVerbs));
      }

      // Due to possible translation nuances, the remove, edit, and move verbs are broken out into
      // their own possible string so that translators can better translate the meaning
      var type;
      if (this.hasStimulus || this.isBank) {
        type = this.hasStimulus ? t('Stimulus') : t('Bank');
        if (this.numItems > 1) {
          var opts = {
            type: type,
            start: displayPosition,
            end: displayPosition + this.numItems - 1
          };
          return {
            Remove: t('Remove {type} containing questions {start, number} through {end, number}.', opts),
            Edit: t('Edit {type} containing questions {start, number} through {end, number}.', opts),
            Move: t('Move {type} containing questions {start, number} through {end, number}.', opts)
          }[verb];
        } else if (this.numItems === 1) {
          var _opts = {
            type: type,
            start: displayPosition
          };
          return {
            Remove: t('Remove {type} containing question {start, number}.', _opts),
            Edit: t('Edit {type} containing question {start, number}.', _opts),
            Move: t('Move {type} containing question {start, number}.', _opts)
          }[verb];
        } else {
          var _opts2 = {
            type: type,
            start: displayPosition - 1
          };
          return {
            Remove: t('Remove empty {type} located after position {start, number}.', _opts2),
            Edit: t('Edit empty {type} located after position {start, number}.', _opts2),
            Move: t('Move empty {type} located after position {start, number}.', _opts2)
          }[verb];
        }
      } else {
        type = t('Question');
        var _opts3 = {
          verb: verb,
          type: type,
          position: displayPosition
        };
        return {
          Remove: t('Remove {type} at position {position, number}.', _opts3),
          Edit: t('Edit {type} at position {position, number}.', _opts3),
          Move: t('Move {type} at position {position, number}.', _opts3),
          Copy: t('Copy {type} at position {position, number}.', _opts3)
        }[verb];
      }
    }
  }, {
    key: "positionToDisplay",
    value: function positionToDisplay(displayPosition) {
      if (this.isBank && this.sizeOfBank > 1 && this.sampleNum !== 1) {
        return t('{first, number} - {second, number}', {
          first: displayPosition,
          second: displayPosition + (this.sizeOfBank - 1) // subtract one for the initial slot
        });
      }
      return t('{position, number}', {
        position: displayPosition
      });
    }
  }, {
    key: "sizeOfBank",
    get: function get() {
      if (!this.isBank) return 0;
      return this.sampleNum || this.getEntry().itemEntryCount;
    }
  }, {
    key: "positionSlots",
    get: function get() {
      if (this.hasNestedRecords) {
        return this.getNestedEntries().size;
      }
      return 1;
    }
  }, {
    key: "displayPositionSlots",
    get: function get() {
      if (this.isBank) {
        return this.sizeOfBank;
      }
      if (this.hasStimulus) {
        return this.getNestedEntries().reduce(function (sum, quizEntry) {
          return sum + quizEntry.displayPositionSlots;
        }, 0);
      }
      return 1;
    }
  }, {
    key: "state",
    value: function state() {
      return this.getState();
    }
  }]);
}(ReduxRecord({
  id: '0',
  entryEditable: true,
  entry: Map(),
  entryId: null,
  entryType: null,
  isWorkingInstance: false,
  pointsPossible: 1,
  position: null,
  properties: Map(),
  regradeAdjustedPointsPossible: null,
  // DEPRECATED in favor of the method with the same name
  regradeAdjustedScoringData: null,
  // DEPRECATED in favor of the method with the same name
  quizEntryRegrades: List(),
  status: 'mutable',
  stimulusQuizEntryId: null,
  sampleItems: []
})), _applyDecoratedDescriptor(_class.prototype, "getNestedEntries", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "getNestedEntries"), _class.prototype), _class);
export default QuizEntry;